import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';

import { USER_EMAIL_SETTINGS_KEY } from '@utils/backend-api/settings';
import {
  SignUpForWeeklyDigestResponse,
  signUpForWeeklyDigest,
} from '@utils/backend-api/signUpForWeeklyDigest';

interface UseSignUpForWeeklyDigestProps {
  skipRedirect: boolean;
}

export default function useSignUpForWeeklyDigest({ skipRedirect }: UseSignUpForWeeklyDigestProps) {
  const queryClient = useQueryClient();
  const { mutate, isLoading, isError } = useMutation(
    async () => {
      const data: SignUpForWeeklyDigestResponse = await signUpForWeeklyDigest();

      if (skipRedirect) {
        toast.success(data?.message);
      } else if (data.redirectUri) {
        window.location.href = data.redirectUri;
      }
      queryClient.invalidateQueries(USER_EMAIL_SETTINGS_KEY);
    },
    {
      onError: (data: SignUpForWeeklyDigestResponse) => {
        toast.error(data?.message);
      },
    }
  );
  return { mutate, isLoading, isError };
}
